import { FONT_FAMILY_WHITE_LIST } from '../../Forms/components/RichTextEditor/Quill/quill.const';

/* eslint-disable @typescript-eslint/naming-convention */
export enum DefaultFontsEnum {
    Arial = 'Arial, Helvetica, sans-serif',
    Comic_Sans = '\'Comic Sans MS\', Helvetica, sans-serif',
    Courier_New = '\'Courier New\', Courier, monospace',
    Georgia = 'Georgia, serif',
    Helvetica = 'Helvetica, Arial, sans-serif',
    Lucida = '\'Lucida Sans Unicode\', \'Lucida Grande\', sans-serif',
    Tahoma = 'Tahoma, Geneva, sans-serif',
    Times = '\'Times New Roman\', Times, serif',
    Trebuchet_MS = '\'Trebuchet MS\', Helvetica, sans-serif',
    Verdana = 'Verdana, Geneva, sans-serif',
    // At some point bad values were added for Arial and Helvetica, these should remain until we're confident no more active briefings are using the old value
    backwardCompatibilityArial = '\'Open Sans\', Arial, Helvetica, sans-serif',
    backwardCompatibilityHelvetica = '\'Open Sans\', Helvetica, Arial, sans-serif'
}

export function getMatchingDefaultFont(fontFamilies: string[]): string {
    let closestFontMatch = '';

    for (const fontFamily of fontFamilies ) {
        const potentialWhiteListMatches = FONT_FAMILY_WHITE_LIST.filter(whiteListFont => whiteListFont.indexOf(fontFamily) > -1);
        if (potentialWhiteListMatches?.length) {
            const sortedWhiteListValues = potentialWhiteListMatches.sort((a, b) => {
                const aPriorityIndex = a.toLowerCase().split(',').map(x => x.trim()).findIndex(x => x === fontFamily.toLowerCase());
                const bPriorityIndex = b.toLowerCase().split(',').map(x => x.trim()).findIndex(x => x === fontFamily.toLowerCase());

                if (aPriorityIndex < bPriorityIndex ) {
                    return -1;
                }

                if (aPriorityIndex > bPriorityIndex) {
                    return 1;
                }

                return 0;
            });

            closestFontMatch = sortedWhiteListValues[0];

            break;
        }
    }

    return closestFontMatch;
}
